import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

//core components
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";

//bootstrap imports
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

//material compenents
import AddAlert from "@material-ui/icons/AddAlert";



function ModalAddProductOrder(props) {
    const [br, setBR] = useState(false);
    const [amount, setAmount] = useState();
    const [price_of_product, setPrice_of_product] = useState();
    const [productId, setProductId] = useState();
    const [product, setProduct] = useState();
    const [products, setProducts] = useState([]);

    const { storageId, user, garlicType, storageUserType } = useAuth();
    const id_admin = { admin: storageId, sellsman: user.id_admin };
    const id_sellsman = { admin: props.props.id_sellsman, sellsman: storageId }

    const [controlSnack, setControlSnack] = useState(false);
    useEffect(() => {
        loadProducts();
    }, [])

    useEffect(() => {
        chooseProduct();
    }, [productId])

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };
    async function handleEditOrder(e) {
        e.preventDefault();
        const response = await api.post('/order', {
            amount,
            price_of_product,
            box: parseFloat(amount / product.box).toFixed(2),
            id_admin: id_admin[storageUserType],
            id_sellsman: id_sellsman[storageUserType],
            id_client: props.props.client.id_client,
            id_product: parseInt(productId),
            order_controller: props.props.order_controller,
            nature_operation: props.props.nature,
            payment_method: props.props.payment,
            observation: props.props.observation,
            date_of_delivery: props.props.date
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        setControlSnack(true);
        props.loadOrders();
        props.onHide();
    }

    async function loadProducts() {
        const response = await api.get(`/product/admin/${id_admin[storageUserType]}?garlic=${garlicType}`);
        setProducts(response.data);
        setProductId(response.data[0].id);
        setProduct(response.data[0]);
    }

    const chooseProduct = async () => {
        const prod = products.filter(item => item.id === parseInt(productId));
        setProduct(prod[0]);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar produto
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditOrder}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} value={productId} as="select" defaultValue="Choose...">
                                {products.map((product, index) => (
                                    <option key={product.id} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} value={amount} type="double" placeholder="Quantidade do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPriceOfProduct">
                            <Form.Label>Preço praticado</Form.Label>
                            <MaskReal onChange={value => setPrice_of_product(value.replace(',', '.'))} value={price_of_product} />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Pedido editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddProductOrder;